export type InsurancePersonTarget =
  | { person: 'policyholder' }
  | { person: 'participant'; participantIndex: number }

export const getInsurancePersonTarget = (
  searchParams: URLSearchParams,
): InsurancePersonTarget | null => {
  const person = searchParams.get('person')

  if (person === 'policyholder') return { person }
  if (person !== 'participant') return null

  const participant = searchParams.get('participant')

  if (!participant || !/^\d+$/.test(participant)) return null

  return { person, participantIndex: Number(participant) }
}
